// import React, { useContext, useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import LoadingIcon from "../../images/Loading_icon.gif";
// import Swal from "sweetalert2";
// import { UrlContext } from "../../contexts/UrlContext";

// export default function ExCreateDigitalPPT({
//   digitalExist,
//   expert_id,
//   project_id,
// }) {
//   const { API_URL } = useContext(UrlContext);
//   const [digitalProfile, setDigitalProfile] = useState(false);
//   const [pptExistingPopup, setPptExistingPopup] = useState(false);
//   const [noExistDimension, setNoExistDimension] = useState(false);
//   const [afterExistDimension, setAfterExistDimension] = useState(false);
//   const [createdPPTList, setCreatedPPTList] = useState(null);
//   const [digitalPPTList, setDigitalPPTList] = useState(null);
//   const [waitingPopup, setWaitingPopup] = useState(false);
//   const [exprj_id, setExprj_id] = useState(null);
//   const [dimensions, setDimensions] = useState({
//     dimension1: "",
//     dimension2: "",
//     dimension3: "",
//     dimension4: "",
//     dimension5: "",
//   });
//   const [expertpptExist, setExpertpptExist] = useState(false);
//   const [loadingPopup, setLoadingPopup] = useState(false);
//   const [hoverIndex, setHoverIndex] = useState(null);
//   const [hoverIndexPhy, setHoverIndexPhy] = useState(null);
//   const [hoverIndexSug, setHoverIndexSug] = useState(null);
//   const [dimensionSuggestions, setDimensionSuggestions] = useState([]);
//   const [projectType, setProjectType] = useState(null);
//   const [hasDimension, setHasDimension] = useState(false);

//   useEffect(() => {
//     if (digitalExist) {
//       setDigitalProfile(true);
//     }
//   }, [digitalExist]);

//   const saveDimensionsHandler = (e) => {
//     setPptExistingPopup(false);
//     setNoExistDimension(false);
//     setAfterExistDimension(false);
//     e.preventDefault();
//     const url = `${API_URL}save-project-dimensions/` + project_id;
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(dimensions),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         createDigitalProfile();
//         setDigitalProfile(true);
//       })
//       .catch((err) => console.log(err));
//   };

//   const existingPPTHandler = (projectID, pptName) => {
//     setPptExistingPopup(false);
//     setWaitingPopup(true);
//     const authToken = localStorage.getItem("accesstoken");
//     const url = `${API_URL}download-existingPPT`;
//     const data = {
//       expertID: expert_id.toString(),
//       projectID: projectID.toString(),
//       currentProjectID: project_id.toString(),
//       pptName: pptName.toString(),
//       authToken: authToken,
//     };
//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(data),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message) {
//           setWaitingPopup(false);
//           Swal.fire({
//             title: "Warning!",
//             text: `File already exist`,
//             icon: "warning",
//             confirmButtonText: "OK",
//           });
//         }
//         // if (!data.digitalPptUrl || !data.newPptUrl) {
//         if (!data.newPptUrl) {
//           setWaitingPopup(false);
//           Swal.fire({
//             title: "Error!",
//             text: `Something Went Wrong`,
//             icon: "error",
//             confirmButtonText: "OK",
//           });
//         }
//         setWaitingPopup(false);
//         // window.open(data.digitalPptUrl, "_blank", "rel=noopener noreferrer");
//         window.open(data.newPptUrl, "_blank", "rel=noopener noreferrer");
//       })
//       .catch((err) => {
//         console.log(err);
//         setWaitingPopup(false);
//         Swal.fire({
//           title: "Error!",
//           text: "Something went wrong",
//           icon: "error",
//         });
//       });
//   };

//   // Create digital profile from an existing ppt
//   const existingDigitalPPTHandler =  async (exprj_id) => {
//     await getDimensionSuggestions();
//     if (projectType==='exp') {
//       setPptExistingPopup(false);
//       await createDigitalProfileFromExistingDigital(exprj_id);
//     } else if (hasDimension === true) {
//       setPptExistingPopup(false);
//       await createDigitalProfileFromExistingDigital(exprj_id);
//     } else {
//       await updateDimensions();
//       setAfterExistDimension(true);
//     }
//   };

//   const createProfileHandler = async () => {
//     setLoadingPopup(true);
//     try {
//       let modifiedUrl = `get-pptExist-dimensions/${project_id}/${expert_id}`;
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setLoadingPopup(false);
//         setExpertpptExist(responseData.pptExist);
//         setCreatedPPTList(responseData.pEx_expert);
//         setDigitalPPTList(responseData.digitalPPTObj);
//         if (responseData.pptExist === "yes") {
//           setPptExistingPopup(true);
//           await getDimensionSuggestions();
//         } else if (responseData.projectType==='exp') {
//           await createDigitalProfile();
//         } else if (responseData.hasDimension===false) {
//           setNoExistDimension(true);
//           await getDimensionSuggestions();
//         } else {
//           await createDigitalProfile();
//         }
//       } else {
//         setLoadingPopup(false);
//         Swal.fire({
//           title: "Error!",
//           text: "Failed to fetch existing powerpoints!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       setLoadingPopup(false);
//       Swal.fire({
//         title: "Error!",
//         text: "Error while calling existing ppt API!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Api to fetch project dimension suggestions
//   const getDimensionSuggestions = async () => {
//     const requestBody = {
//       projectID: project_id
//     };
//     try {
//       let modifiedUrl = "get-project-dimensions";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setDimensionSuggestions(responseData.dimensions);
//         setProjectType(responseData.projectType);
//         if (responseData.hasDimension) {
//           setHasDimension(true);
//         }
//         updateDimensions();
//       } else {
//         console.error("Failed to get language");
//         Swal.fire({
//           title: "Error!",
//           text: "Failed to fetch existing powerpoints!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to fetch existing powerpoints!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Api to create new power
//   const createDigitalProfile = async () => {
//     setLoadingPopup(true);
//     const requestBody = {
//       projectID: project_id,
//       expertID: expert_id
//     };
//     try {
//       let modifiedUrl = "create-digital-profile";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setDigitalProfile(true);
//         setLoadingPopup(false);
//         window.open(
//           `/app/PreviewDigitalPPT/${project_id}/${expert_id}/${exprj_id}`,
//           "_blank"
//         );
//       } else {
//         console.error("Failed to get language");
//         setLoadingPopup(false);
//         Swal.fire({
//           title: "Error!",
//           text: responseData.text,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       setLoadingPopup(false);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to fetch existing powerpoints!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Api to create new power
//   const createDigitalProfileFromExistingDigital = async (existingProjectID) => {
//     setLoadingPopup(true);
//     const requestBody = {
//       existingProjectID: existingProjectID,
//       currentProjectID: project_id,
//       expertID: expert_id
//     };
//     try {
//       let modifiedUrl = "create-digital-profile-from-existing-digital";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setDigitalProfile(true);
//         setLoadingPopup(false);
//         window.open(
//           `/app/PreviewDigitalPPT/${project_id}/${expert_id}/${exprj_id}`,
//           "_blank"
//         );
//       } else if (responseData.status==='error') {
//         console.error("Failed to get language");
//         setLoadingPopup(false);
//         Swal.fire({
//           title: "Error!",
//           text: responseData.text,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       setLoadingPopup(false);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to fetch existing powerpoints!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Api to create new powerpoint from existing physical
//   const createDigitalProfileFromExistingPhysical = async () => {
//     setLoadingPopup(true);
//     const requestBody = {
//       projectID: project_id,
//       expertID: expert_id
//     };
//     try {
//       let modifiedUrl = "create-digital-profile-from-existing-physical";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setDigitalProfile(true);
//         setLoadingPopup(false);
//         window.open(
//           `/app/PreviewDigitalPPT/${project_id}/${expert_id}/${exprj_id}`,
//           "_blank"
//         );
//       } else if (responseData.status==='error') {
//         console.error("Failed to get language");
//         setLoadingPopup(false);
//         Swal.fire({
//           title: "Error!",
//           text: responseData.text,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       setLoadingPopup(false);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to fetch existing powerpoints!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };


//   const createNewPPTHandler = async () => {
//     if (hasDimension) {
//       setPptExistingPopup(false);
//       await createDigitalProfile();
//     } else if (projectType==='exp') {
//       setPptExistingPopup(false);
//       await createDigitalProfile();
//     } else {
//       await updateDimensions();
//       setAfterExistDimension(true);
//     }
//   };
  
//   const updateDimensions = async () => {
//     console.log('Dimension Data: ',dimensionSuggestions);
//     if (dimensionSuggestions) {
//       setDimensions({
//         ...dimensions,
//         dimension1: dimensionSuggestions?.dimension1,
//         dimension2: dimensionSuggestions?.dimension2,
//         dimension3: dimensionSuggestions?.dimension3,
//         dimension4: dimensionSuggestions?.dimension4?.length === 1 ? dimensionSuggestions?.dimension4?.[0] : null,
//         dimension5: dimensionSuggestions?.dimension5?.length === 1 ? dimensionSuggestions?.dimension5?.[0] : null,
//     });
//       console.log('after updating the dimensions: ', dimensions);
//     }
//   };

//   return (
//     <>
//       {digitalProfile ? (
//         <Link
//           to={`/app/PreviewDigitalPPT/${project_id}/${expert_id}/${exprj_id}`}
//           target="_blank"
//           rel="noreferrer"
//         >
//           <button className="btn">Modify Profile</button>
//         </Link>
//       ) : (
//         <button className="btn" onClick={() => {createProfileHandler()}}>
//           Create Profile
//         </button>
//       )}

//       {pptExistingPopup && expertpptExist && (
//         <>
//           <div className="decline-wrapper">
//             <div className="flex-container-decline-profile" style={{width: "60%", height: "60%", overflow: "hidden", padding: "0px"}}>

//               <div className="flex-item-decline-profile-header" style={{flex: "2%", backgroundColor: "#365561"}}>
//                 <p style={{fontSize: "16px", fontWeight: "500", marginLeft: "5px", color: "white"}}>Existing Digital and Physical Powerpoints</p>
//                 <i 
//                   class="fa-solid fa-xmark" 
//                   style={{
//                     marginRight: "5px", 
//                     marginTop: "3px", 
//                     color: "gray", 
//                     cursor: "pointer"
//                   }}
//                   onClick={() =>setPptExistingPopup(false)}
//                 />
//               </div>

//               <div className="flex-item-sugest-time-slot-calendar" style={{flex: "96%"}}>
//                 {/* {digitalPPTList && (
//                   <>
//                   <div style={{padding: "5px", width: "30%"}}><p style={{fontSize: "16px", fontWeight: "500", borderBottom: "1px solid lightgrey"}}>Digital Powerpoints</p></div>
//                   <div style=
//                     {{
//                       display: "grid", 
//                       gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))", 
//                       gap: "10px", 
//                       justifyContent: "center", 
//                       alignItems: "center",
//                       padding: "10px",
//                       marginBottom: "10px"
//                     }}
//                   >
//                     {digitalPPTList.map((project, index) => (
//                       <div 
//                         key={index} 
//                         style={{cursor: "pointer", display: "flex", flexDirection: "row", gap: "5px", background: hoverIndex===index? "#D5EEF9" : null, padding: "5px", alignItems: "center", justifyContent: "flex-start", borderRadius: "5px"}} 
//                         onClick={() => existingDigitalPPTHandler(project.projectID)}
//                         onMouseEnter={() => setHoverIndex(index)}
//                         onMouseLeave={() => setHoverIndex(null)}
//                       >
//                         <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start"}} ><i class="fa-regular fa-address-card" style={{color: "#365561", fontSize: "20px"}}></i></div>
//                         <p style={{marginLeft: "5px"}}>{project.digitalPowerPointName}</p>
//                       </div>
//                     ))}
//                   </div>
//                   </>
//                 )} */}
//                 {digitalPPTList && (
//                   <>
//                     <div className="p-1 w-1/3">
//                       <p className="text-base font-medium border-b border-gray-300">Digital Powerpoints</p>
//                     </div>
//                     <div
//                       className="grid gap-2 p-2 mb-2"
//                       style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))' }}
//                     >
//                       {digitalPPTList.map((project) => (
//                         <div
//                           key={project.projectID}
//                           className="relative flex flex-row items-center justify-start gap-1 p-1 rounded cursor-pointer hover:bg-blue-100 group"
//                           onClick={() => existingDigitalPPTHandler(project.projectID)}
//                         >
//                           <div className="flex items-center justify-start">
//                             <i className="fa-regular fa-address-card text-[20px] text-[#365561]"></i>
//                           </div>
//                           <div className="relative ml-1 w-full truncate">
//                             <div className="truncate">{project.digitalPowerPointName}</div>
//                           </div>
//                           {/* Tooltip (separate from truncation, no clipping) */}
//                           <div className="absolute z-10 hidden group-hover:block bg-gray-100 text-sm text-gray-800 p-2 rounded shadow-lg border border-gray-200 top-full mt-1 left-0 w-max max-w-xs">
//                             <div
//                               dangerouslySetInnerHTML={{
//                                 __html: project.summary || '<p>No summary available</p>',
//                               }}
//                             />
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </>
//                 )}


//                 {createdPPTList && (
//                   <>
//                     <div className="p-1 w-1/3">
//                       <p className="text-base font-medium border-b border-gray-300">Physical Powerpoints</p>
//                     </div>
//                     <div
//                       className="grid gap-2 p-2 mb-2"
//                       style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))' }}
//                     >
//                       {createdPPTList.length > 0 ? (
//                         <>
//                           {createdPPTList.map((project, index) => (
//                             <div 
//                               key={index} 
//                               className="relative flex flex-row items-center justify-start gap-1 p-1 rounded cursor-pointer hover:bg-blue-100 group" 
//                               onClick={() => {existingPPTHandler( project.project_id,project.pptExist); createDigitalProfileFromExistingPhysical()}}
//                             >
//                               <div className="flex items-center justify-start">
//                                 <i className="fa-regular fa-file-powerpoint text-[20px] text-[#365561]"></i>
//                               </div>
//                               <div className="relative ml-1 w-full truncate">
//                                 <div className="truncate">{project.pptExist}</div>
//                               </div>
//                             </div>
//                           ))}
//                         </>
//                       ) : (
//                         <p className="text-gray-500">No physical powerpoints available</p>
//                       )}
//                     </div>
//                   </>
//                 )}
//               </div>
              
//               <div style={{flex: "2%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px"}}>
//                 <button
//                   type="button"
//                   className="btn btn-light"
//                   onClick={() => setPptExistingPopup(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn base-btn"
//                   onClick={createNewPPTHandler}
//                 >
//                   Create New PPT
//                 </button>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {noExistDimension && !expertpptExist && (
//         <>
//           <div className="decline-wrapper">
//             <div className="flex-container-decline-profile" style={{width: "60%", height: "60%", overflow: "hidden", padding: "0px"}}>

//               <div className="flex-item-decline-profile-header" style={{flex: "2%", backgroundColor: "#365561"}}>
//                 <p style={{fontSize: "16px", fontWeight: "500", marginLeft: "5px", color: "white"}}>Enter Dimensions</p>
//                 <i 
//                   class="fa-solid fa-xmark" 
//                   style={{
//                     marginRight: "5px", 
//                     marginTop: "3px", 
//                     color: "gray", 
//                     cursor: "pointer"
//                   }}
//                   onClick={() =>setNoExistDimension(false)}
//                 />
//               </div>

//               <div className="flex-item-sugest-time-slot-calendar" style={{flex: "96%", height: "100%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px", padding: "10px"}}>
//                 <div style={{flex: "50%", display: "flex", flexDirection: "column", gap: "5px"}}>
                  
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 1:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension1}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension1: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 2:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension2}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension2: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 3:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension3}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension3: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 4:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension4}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension4: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 5:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension5}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension5: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
                  
//                 </div>
//                 {dimensionSuggestions?.dimension4?.length>1 || dimensionSuggestions?.dimension4?.length>1 ? (
//                   <div style={{flex: "50%", display: "flex", flexDirection: "row", gap: "5px", justifyContent: "center"}}>
//                     <div style={{display: "flex", flexDirection: "column", gap: "5px", justifyContent: "center"}}>
//                       {dimensionSuggestions?.dimension4?.length>1 && (
//                         <>
//                           <p style={{fontWeight: "500"}}>Suggestions for Dimension4:</p>
//                           {dimensionSuggestions?.dimension4?.map((dimensionItem, index) =>
//                             <p style={{fontSize: "12px", marginLeft: "10px", cursor: "pointer"}} key={index} onClick={() => setDimensions({...dimensions, dimension4: dimensionItem})}>{index+1}{'.  '}{dimensionItem}</p>
//                           )}
//                         </>
//                       )}
//                       {dimensionSuggestions?.dimension5?.length>1 && (
//                         <>
//                           <p style={{fontWeight: "500"}}>Suggestions for Dimension5:</p>
//                           {dimensionSuggestions?.dimension5?.map((dimensionItem, index) =>
//                             <p style={{fontSize: "12px", marginLeft: "10px", cursor: "pointer"}} key={index} onClick={() => setDimensions({...dimensions, dimension5: dimensionItem})}>{index+1}{'.  '}{dimensionItem}</p>
//                           )}
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 ):(null)}
//               </div>
              
//               <div style={{flex: "2%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px"}}>
//                 <button
//                   type="button"
//                   className="btn btn-light"
//                   onClick={() => setNoExistDimension(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn base-btn"
//                   onClick={saveDimensionsHandler}
//                 >
//                   Create New PPT
//                 </button>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {afterExistDimension && (
//         <>
//           <div className="decline-wrapper-subset">
//             <div className="flex-container-decline-profile" style={{width: "60%", height: "60%", overflow: "hidden", padding: "0px"}}>

//               <div className="flex-item-decline-profile-header" style={{flex: "2%", backgroundColor: "#365561"}}>
//                 <p style={{fontSize: "16px", fontWeight: "500", marginLeft: "5px", color: "white"}}>Enter Dimensions</p>
//                 <i 
//                   class="fa-solid fa-xmark" 
//                   style={{
//                     marginRight: "5px", 
//                     marginTop: "3px", 
//                     color: "gray", 
//                     cursor: "pointer"
//                   }}
//                   onClick={() =>setAfterExistDimension(false)}
//                 />
//               </div>

//               <div className="flex-item-sugest-time-slot-calendar" style={{flex: "96%", height: "100%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px", padding: "10px"}}>
//                 <div style={{flex: "50%", display: "flex", flexDirection: "column", gap: "5px"}}>
                  
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 1:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension1}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension1: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 2:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension2}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension2: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 3:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension3}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension3: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 4:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension4}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension4: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div 
//                     style={{display: "flex", flexDirection: "row", padding: "5px", justifyContent: "flex-start", alignItems: "center", gap: "5px"}}
//                   >
//                     <p style={{ flex: "1 0 96px", fontWeight: "500"}}>Dimension 5:</p>
//                     <div className="input-attendees-subject" style={{width: "100%", marginTop: "2px"}}>
//                       <input
//                         style={{outline: "none", width: "100%"}}
//                         value={dimensions.dimension5}
//                         onChange={(e) =>
//                           setDimensions({
//                             ...dimensions,
//                             dimension5: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
                  
//                 </div>
//                 {dimensionSuggestions?.dimension4?.length>1 || dimensionSuggestions?.dimension4?.length>1 ? (
//                   <div style={{flex: "50%", display: "flex", flexDirection: "row", gap: "5px", justifyContent: "center"}}>
//                     <div style={{display: "flex", flexDirection: "column", gap: "5px", justifyContent: "center"}}>
//                       {dimensionSuggestions?.dimension4?.length>1 && (
//                         <>
//                           <p style={{fontWeight: "500"}}>Suggestions for Dimension 4:</p>
//                           {dimensionSuggestions?.dimension4?.map((dimensionItem, index) =>
//                             <p 
//                               style={{fontSize: "12px", marginLeft: "10px", cursor: "pointer", textShadow: index===hoverIndexSug ? "0 0 10px #365561" : "none", transition: "all 0.3s ease"}} 
//                               key={index} 
//                               onClick={() => setDimensions({...dimensions, dimension4: dimensionItem})}
//                               onMouseEnter={() => setHoverIndexSug(index)}
//                               onMouseLeave={() => setHoverIndexSug(null)}
//                             >{index+1}{'.  '}{dimensionItem}</p>
//                           )}
//                         </>
//                       )}
//                       {dimensionSuggestions?.dimension5?.length>1 && (
//                         <>
//                           <p style={{fontWeight: "500"}}>Suggestions for Dimension 5:</p>
//                           {dimensionSuggestions?.dimension5?.map((dimensionItem, index) =>
//                             <p style={{fontSize: "12px", marginLeft: "10px", cursor: "pointer"}} key={index} onClick={() => setDimensions({...dimensions, dimension5: dimensionItem})}>{index+1}{'.  '}{dimensionItem}</p>
//                           )}
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 ):(null)}
//               </div>
              
//               <div style={{flex: "2%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px"}}>
//                 <button
//                   type="button"
//                   className="btn btn-light"
//                   onClick={() => setAfterExistDimension(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn base-btn"
//                   onClick={saveDimensionsHandler}
//                 >
//                   Create New PPT
//                 </button>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {waitingPopup && (
//         <div  className="decline-wrapper">
//           <div className="flex-container-decline-profile" style={{width: "60%", height: "60%", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
//             <center>
//               <p style={{ fontSize: "18px" }}>Existing PPT is downloading..</p>
//               <br />
//               <img
//                 src={LoadingIcon}
//                 alt=""
//                 style={{ width: "50px", marginRight: "5px" }}
//               />
//             </center>
//           </div>
//         </div>
//       )}

//       {loadingPopup && (
//         <div className="decline-wrapper">
//           <div className="flex-container-decline-profile" style={{width: "60%", height: "60%", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
//             <center>
//               <p style={{ fontSize: "18px" }}>Loading data. Please wait..</p>
//               <br />
//               <img
//                 src={LoadingIcon}
//                 alt=""
//                 style={{ width: "50px", marginRight: "5px" }}
//               />
//             </center>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


// new profile creation button
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExCreateDigitalPPT({
  digitalExist,
  expert_id,
  project_id,
}) {
  const { API_URL } = useContext(UrlContext);

  const [digitalProfile, setDigitalProfile] = useState(!!digitalExist);
  const [exprj_id, setExprj_id] = useState(null);

  const [modals, setModals] = useState({
    existingProfiles: false,
    dimensions: false,
    waiting: false,
    loading: false,
  });

  const [projectInfo, setProjectInfo] = useState({
    projectType: null,
    hasDimension: false,
    dimensionSuggestions: {
      dimension1: "",
      dimension2: "",
      dimension3: "",
      dimension4: [],
      dimension5: [],
    },
  });

  const [dimensions, setDimensions] = useState({
    dimension1: "",
    dimension2: "",
    dimension3: "",
    dimension4: "",
    dimension5: "",
  });

  const [pptData, setPptData] = useState({
    expertpptExist: false,
    createdPPTList: [],
    digitalPPTList: [],
  });

  const [pendingAction, setPendingAction] = useState({
    type: null, // "new" | "existingDigital" | "existingPhysical"
    selectedExistingDigitalProjectId: null,
    selectedPhysicalProjectId: null,
    selectedPhysicalPptName: null,
  });

  useEffect(() => {
    setDigitalProfile(!!digitalExist);
  }, [digitalExist]);

  const previewUrl = useMemo(() => {
    return `/app/PreviewDigitalPPT/${project_id}/${expert_id}/${exprj_id}`;
  }, [project_id, expert_id, exprj_id]);

  const setLoading = (value) => {
    setModals((prev) => ({ ...prev, loading: value }));
  };

  const setWaiting = (value) => {
    setModals((prev) => ({ ...prev, waiting: value }));
  };

  const openExistingProfilesModal = () => {
    setModals((prev) => ({ ...prev, existingProfiles: true }));
  };

  const closeExistingProfilesModal = () => {
    setModals((prev) => ({ ...prev, existingProfiles: false }));
  };

  const openDimensionsModal = () => {
    setModals((prev) => ({ ...prev, dimensions: true }));
  };

  const closeDimensionsModal = () => {
    setModals((prev) => ({ ...prev, dimensions: false }));
  };

  const showError = (text) => {
    Swal.fire({
      title: "Error!",
      text,
      icon: "error",
      confirmButtonText: "OK",
    });
  };

  const showWarning = (text) => {
    Swal.fire({
      title: "Warning!",
      text,
      icon: "warning",
      confirmButtonText: "OK",
    });
  };

  const normalizeDimensionsFromSuggestions = (suggestions = {}) => {
    return {
      dimension1: suggestions?.dimension1 || "",
      dimension2: suggestions?.dimension2 || "",
      dimension3: suggestions?.dimension3 || "",
      dimension4:
        Array.isArray(suggestions?.dimension4) && suggestions.dimension4.length === 1
          ? suggestions.dimension4[0]
          : "",
      dimension5:
        Array.isArray(suggestions?.dimension5) && suggestions.dimension5.length === 1
          ? suggestions.dimension5[0]
          : "",
    };
  };

  const extractExprjId = (responseData) => {
    return (
      responseData?.exprj_id ??
      responseData?.exprjID ??
      responseData?.exprjId ??
      responseData?.expert_project_id ??
      responseData?.expertProjectId ??
      null
    );
  };

  const openPreview = (responseData) => {
    const nextExprjId = extractExprjId(responseData);

    if (nextExprjId !== null && nextExprjId !== undefined) {
      setExprj_id(nextExprjId);
      window.open(
        `/app/PreviewDigitalPPT/${project_id}/${expert_id}/${nextExprjId}`,
        "_blank"
      );
      return;
    }

    // Fallback to current state if backend did not return it
    window.open(
      `/app/PreviewDigitalPPT/${project_id}/${expert_id}/${exprj_id}`,
      "_blank"
    );
  };

  const fetchProjectDimensionInfo = async () => {
    const response = await fetch(`${API_URL}get-project-dimensions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ projectID: project_id }),
    });

    const responseData = await response.json();

    if (responseData.status !== "success") {
      throw new Error("Failed to fetch project dimensions.");
    }

    const nextProjectInfo = {
      projectType: responseData.projectType,
      hasDimension: !!responseData.hasDimension,
      dimensionSuggestions: responseData.dimensions || {
        dimension1: "",
        dimension2: "",
        dimension3: "",
        dimension4: [],
        dimension5: [],
      },
    };

    setProjectInfo(nextProjectInfo);
    setDimensions((prev) => ({
      ...prev,
      ...normalizeDimensionsFromSuggestions(nextProjectInfo.dimensionSuggestions),
    }));

    return nextProjectInfo;
  };

  const fetchExistingProfilesAndProjectState = async () => {
    const response = await fetch(
      `${API_URL}get-pptExist-dimensions/${project_id}/${expert_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const responseData = await response.json();

    if (responseData.status !== "success") {
      throw new Error("Failed to fetch existing powerpoints.");
    }

    const nextPptData = {
      expertpptExist: responseData.pptExist === "yes",
      createdPPTList: responseData.pEx_expert || [],
      digitalPPTList: responseData.digitalPPTObj || [],
    };

    setPptData(nextPptData);

    const nextProjectInfo = {
      projectType: responseData.projectType,
      hasDimension: !!responseData.hasDimension,
      dimensionSuggestions: projectInfo.dimensionSuggestions,
    };

    setProjectInfo((prev) => ({
      ...prev,
      projectType: nextProjectInfo.projectType,
      hasDimension: nextProjectInfo.hasDimension,
    }));

    return {
      ...nextPptData,
      ...nextProjectInfo,
    };
  };

  const saveProjectDimensions = async () => {
    const response = await fetch(`${API_URL}save-project-dimensions/${project_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dimensions),
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData?.text || "Failed to save project dimensions.");
    }

    return responseData;
  };

  const createDigitalProfile = async () => {
    const response = await fetch(`${API_URL}create-digital-profile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        projectID: project_id,
        expertID: expert_id,
      }),
    });

    const responseData = await response.json();

    if (responseData.status !== "success") {
      throw new Error(responseData?.text || "Failed to create digital profile.");
    }

    setDigitalProfile(true);
    openPreview(responseData);
    return responseData;
  };

  const createDigitalProfileFromExistingDigital = async (existingProjectID) => {
    const response = await fetch(
      `${API_URL}create-digital-profile-from-existing-digital`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          existingProjectID,
          currentProjectID: project_id,
          expertID: expert_id,
        }),
      }
    );

    const responseData = await response.json();

    if (responseData.status !== "success") {
      throw new Error(
        responseData?.text || "Failed to create profile from existing digital profile."
      );
    }

    setDigitalProfile(true);
    openPreview(responseData);
    return responseData;
  };

  const createDigitalProfileFromExistingPhysical = async () => {
    const response = await fetch(
      `${API_URL}create-digital-profile-from-existing-physical`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          projectID: project_id,
          expertID: expert_id,
        }),
      }
    );

    const responseData = await response.json();

    if (responseData.status !== "success") {
      throw new Error(
        responseData?.text || "Failed to create profile from existing physical profile."
      );
    }

    setDigitalProfile(true);
    openPreview(responseData);
    return responseData;
  };

  const downloadExistingPhysicalPPT = async (projectID, pptName) => {
    setWaiting(true);

    try {
      const authToken = localStorage.getItem("accesstoken");

      const response = await fetch(`${API_URL}download-existingPPT`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expertID: expert_id.toString(),
          projectID: projectID.toString(),
          currentProjectID: project_id.toString(),
          pptName: pptName.toString(),
          authToken,
        }),
      });

      const responseData = await response.json();

      if (responseData.message) {
        showWarning("File already exist");
      }

      if (!responseData.newPptUrl) {
        throw new Error("Something went wrong while downloading existing PPT.");
      }

      window.open(responseData.newPptUrl, "_blank", "rel=noopener noreferrer");
      return responseData;
    } finally {
      setWaiting(false);
    }
  };

  const shouldAskForDimensions = (info) => {
    if (info.projectType === "exp") return false;
    if (info.hasDimension) return false;
    return true;
  };

  const runPendingCreation = async () => {
    if (pendingAction.type === "existingDigital") {
      if (!pendingAction.selectedExistingDigitalProjectId) {
        throw new Error("No existing digital profile selected.");
      }
      return createDigitalProfileFromExistingDigital(
        pendingAction.selectedExistingDigitalProjectId
      );
    }

    if (pendingAction.type === "existingPhysical") {
      if (
        pendingAction.selectedPhysicalProjectId &&
        pendingAction.selectedPhysicalPptName
      ) {
        await downloadExistingPhysicalPPT(
          pendingAction.selectedPhysicalProjectId,
          pendingAction.selectedPhysicalPptName
        );
      }
      return createDigitalProfileFromExistingPhysical();
    }

    return createDigitalProfile();
  };

  const createProfileHandler = async () => {
    setLoading(true);

    try {
      const data = await fetchExistingProfilesAndProjectState();

      if (data.expertpptExist) {
        await fetchProjectDimensionInfo();
        openExistingProfilesModal();
        return;
      }

      setPendingAction({
        type: "new",
        selectedExistingDigitalProjectId: null,
        selectedPhysicalProjectId: null,
        selectedPhysicalPptName: null,
      });

      if (shouldAskForDimensions(data)) {
        await fetchProjectDimensionInfo();
        openDimensionsModal();
        return;
      }

      await createDigitalProfile();
    } catch (error) {
      console.error(error);
      showError(error.message || "Error while creating profile.");
    } finally {
      setLoading(false);
    }
  };

  const handleCreateNew = async () => {
    setLoading(true);

    try {
      setPendingAction({
        type: "new",
        selectedExistingDigitalProjectId: null,
        selectedPhysicalProjectId: null,
        selectedPhysicalPptName: null,
      });

      const info = await fetchProjectDimensionInfo();

      if (shouldAskForDimensions(info)) {
        closeExistingProfilesModal();
        openDimensionsModal();
        return;
      }

      closeExistingProfilesModal();
      await createDigitalProfile();
    } catch (error) {
      console.error(error);
      showError(error.message || "Failed to create new profile.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectExistingDigital = async (existingProjectId) => {
    setLoading(true);

    try {
      setPendingAction({
        type: "existingDigital",
        selectedExistingDigitalProjectId: existingProjectId,
        selectedPhysicalProjectId: null,
        selectedPhysicalPptName: null,
      });

      const info = await fetchProjectDimensionInfo();

      if (shouldAskForDimensions(info)) {
        closeExistingProfilesModal();
        openDimensionsModal();
        return;
      }

      closeExistingProfilesModal();
      await createDigitalProfileFromExistingDigital(existingProjectId);
    } catch (error) {
      console.error(error);
      showError(error.message || "Failed to create from existing digital profile.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectExistingPhysical = async (projectID, pptName) => {
    setLoading(true);

    try {
      setPendingAction({
        type: "existingPhysical",
        selectedExistingDigitalProjectId: null,
        selectedPhysicalProjectId: projectID,
        selectedPhysicalPptName: pptName,
      });

      const info = await fetchProjectDimensionInfo();

      if (shouldAskForDimensions(info)) {
        closeExistingProfilesModal();
        openDimensionsModal();
        return;
      }

      closeExistingProfilesModal();
      await downloadExistingPhysicalPPT(projectID, pptName);
      await createDigitalProfileFromExistingPhysical();
    } catch (error) {
      console.error(error);
      showError(error.message || "Failed to create from existing physical profile.");
    } finally {
      setLoading(false);
    }
  };

  const saveDimensionsHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await saveProjectDimensions();
      closeDimensionsModal();
      await runPendingCreation();
    } catch (error) {
      console.error(error);
      showError(error.message || "Failed to save dimensions and create profile.");
    } finally {
      setLoading(false);
    }
  };

  const skipDimensionsHandler = async () => {
    setLoading(true);

    try {
      closeDimensionsModal();
      await runPendingCreation();
    } catch (error) {
      console.error(error);
      showError(error.message || "Failed to continue without dimensions.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {digitalProfile ? (
        <Link to={previewUrl} target="_blank" rel="noreferrer">
          <button className="btn">Modify Profile</button>
        </Link>
      ) : (
        <button className="btn" onClick={createProfileHandler}>
          Create Profile
        </button>
      )}

      {modals.existingProfiles && (
        <ExistingProfilesModal
          digitalPPTList={pptData.digitalPPTList}
          createdPPTList={pptData.createdPPTList}
          onClose={closeExistingProfilesModal}
          onCreateNew={handleCreateNew}
          onSelectDigital={handleSelectExistingDigital}
          onSelectPhysical={handleSelectExistingPhysical}
        />
      )}

      {modals.dimensions && (
        <DimensionsModal
          dimensions={dimensions}
          setDimensions={setDimensions}
          dimensionSuggestions={projectInfo.dimensionSuggestions}
          onClose={closeDimensionsModal}
          onSave={saveDimensionsHandler}
          onSkip={skipDimensionsHandler}
        />
      )}

      {modals.waiting && (
        <LoadingModal
          text="Existing PPT is downloading.."
          image={LoadingIcon}
        />
      )}

      {modals.loading && (
        <LoadingModal
          text="Loading data. Please wait.."
          image={LoadingIcon}
        />
      )}
    </>
  );
}

function ExistingProfilesModal({
  digitalPPTList,
  createdPPTList,
  onClose,
  onCreateNew,
  onSelectDigital,
  onSelectPhysical,
}) {
  return (
    <div className="decline-wrapper">
      <div
        className="flex-container-decline-profile"
        style={{ width: "60%", height: "60%", overflow: "hidden", padding: "0px" }}
      >
        <div
          className="flex-item-decline-profile-header"
          style={{ flex: "2%", backgroundColor: "#365561" }}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: "500",
              marginLeft: "5px",
              color: "white",
            }}
          >
            Existing Digital and Physical Powerpoints
          </p>
          <i
            className="fa-solid fa-xmark"
            style={{
              marginRight: "5px",
              marginTop: "3px",
              color: "gray",
              cursor: "pointer",
            }}
            onClick={onClose}
          />
        </div>

        <div className="flex-item-sugest-time-slot-calendar" style={{ flex: "96%" }}>
          {!!digitalPPTList?.length && (
            <>
              <div className="p-1 w-1/3">
                <p className="text-base font-medium border-b border-gray-300">
                  Digital Powerpoints
                </p>
              </div>
              <div
                className="grid gap-2 p-2 mb-2"
                style={{ gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))" }}
              >
                {digitalPPTList.map((project) => (
                  <div
                    key={project.projectID}
                    className="relative flex flex-row items-center justify-start gap-1 p-1 rounded cursor-pointer hover:bg-blue-100 group"
                    onClick={() => onSelectDigital(project.projectID)}
                  >
                    <div className="flex items-center justify-start">
                      <i className="fa-regular fa-address-card text-[20px] text-[#365561]"></i>
                    </div>
                    <div className="relative ml-1 w-full truncate">
                      <div className="truncate">{project.digitalPowerPointName}</div>
                    </div>
                    <div className="absolute z-10 hidden group-hover:block bg-gray-100 text-sm text-gray-800 p-2 rounded shadow-lg border border-gray-200 top-full mt-1 left-0 w-max max-w-xs">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: project.summary || "<p>No summary available</p>",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="p-1 w-1/3">
            <p className="text-base font-medium border-b border-gray-300">
              Physical Powerpoints
            </p>
          </div>
          <div
            className="grid gap-2 p-2 mb-2"
            style={{ gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))" }}
          >
            {createdPPTList?.length > 0 ? (
              createdPPTList.map((project, index) => (
                <div
                  key={`${project.project_id}-${index}`}
                  className="relative flex flex-row items-center justify-start gap-1 p-1 rounded cursor-pointer hover:bg-blue-100 group"
                  onClick={() => onSelectPhysical(project.project_id, project.pptExist)}
                >
                  <div className="flex items-center justify-start">
                    <i className="fa-regular fa-file-powerpoint text-[20px] text-[#365561]"></i>
                  </div>
                  <div className="relative ml-1 w-full truncate">
                    <div className="truncate">{project.pptExist}</div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-500">No physical powerpoints available</p>
            )}
          </div>
        </div>

        <div
          style={{
            flex: "2%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button type="button" className="btn btn-light" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn base-btn" onClick={onCreateNew}>
            Create Profile
          </button>
        </div>
      </div>
    </div>
  );
}

function DimensionsModal({
  dimensions,
  setDimensions,
  dimensionSuggestions,
  onClose,
  onSave,
  onSkip,
}) {
  const hasDimension4Suggestions =
    Array.isArray(dimensionSuggestions?.dimension4) &&
    dimensionSuggestions.dimension4.length > 1;

  const hasDimension5Suggestions =
    Array.isArray(dimensionSuggestions?.dimension5) &&
    dimensionSuggestions.dimension5.length > 1;

  return (
    <div className="decline-wrapper">
      <div
        className="flex-container-decline-profile"
        style={{ width: "60%", height: "60%", overflow: "hidden", padding: "0px" }}
      >
        <div
          className="flex-item-decline-profile-header"
          style={{ flex: "2%", backgroundColor: "#365561" }}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: "500",
              marginLeft: "5px",
              color: "white",
            }}
          >
            Enter Dimensions
          </p>
          <i
            className="fa-solid fa-xmark"
            style={{
              marginRight: "5px",
              marginTop: "3px",
              color: "gray",
              cursor: "pointer",
            }}
            onClick={onClose}
          />
        </div>

        <form
          onSubmit={onSave}
          className="flex-item-sugest-time-slot-calendar"
          style={{
            flex: "96%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            padding: "10px",
          }}
        >
          <div
            style={{
              flex: "50%",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <DimensionInput
              label="Dimension 1"
              value={dimensions.dimension1}
              onChange={(value) =>
                setDimensions((prev) => ({ ...prev, dimension1: value }))
              }
            />
            <DimensionInput
              label="Dimension 2"
              value={dimensions.dimension2}
              onChange={(value) =>
                setDimensions((prev) => ({ ...prev, dimension2: value }))
              }
            />
            <DimensionInput
              label="Dimension 3"
              value={dimensions.dimension3}
              onChange={(value) =>
                setDimensions((prev) => ({ ...prev, dimension3: value }))
              }
            />
            <DimensionInput
              label="Dimension 4"
              value={dimensions.dimension4}
              onChange={(value) =>
                setDimensions((prev) => ({ ...prev, dimension4: value }))
              }
            />
            <DimensionInput
              label="Dimension 5"
              value={dimensions.dimension5}
              onChange={(value) =>
                setDimensions((prev) => ({ ...prev, dimension5: value }))
              }
            />
          </div>

          {(hasDimension4Suggestions || hasDimension5Suggestions) && (
            <div
              style={{
                flex: "50%",
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  justifyContent: "center",
                }}
              >
                {hasDimension4Suggestions && (
                  <>
                    <p style={{ fontWeight: "500" }}>Suggestions for Dimension 4:</p>
                    {dimensionSuggestions.dimension4.map((item, index) => (
                      <p
                        key={`d4-${index}`}
                        style={{
                          fontSize: "12px",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setDimensions((prev) => ({ ...prev, dimension4: item }))
                        }
                      >
                        {index + 1}. {item}
                      </p>
                    ))}
                  </>
                )}

                {hasDimension5Suggestions && (
                  <>
                    <p style={{ fontWeight: "500" }}>Suggestions for Dimension 5:</p>
                    {dimensionSuggestions.dimension5.map((item, index) => (
                      <p
                        key={`d5-${index}`}
                        style={{
                          fontSize: "12px",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setDimensions((prev) => ({ ...prev, dimension5: item }))
                        }
                      >
                        {index + 1}. {item}
                      </p>
                    ))}
                  </>
                )}
              </div>
            </div>
          )}
        </form>

        <div
          style={{
            flex: "2%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button type="button" className="btn btn-light" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-light" onClick={onSkip}>
            Skip & Create Profile
          </button>
          <button type="button" className="btn base-btn" onClick={onSave}>
            Save & Create profile
          </button>
        </div>
      </div>
    </div>
  );
}

function DimensionInput({ label, value, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        padding: "5px",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "5px",
      }}
    >
      <p style={{ flex: "1 0 96px", fontWeight: "500" }}>{label}:</p>
      <div className="input-attendees-subject" style={{ width: "100%", marginTop: "2px" }}>
        <input
          style={{ outline: "none", width: "100%" }}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

function LoadingModal({ text, image }) {
  return (
    <div className="decline-wrapper">
      <div
        className="flex-container-decline-profile"
        style={{
          width: "60%",
          height: "60%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <center>
          <p style={{ fontSize: "18px" }}>{text}</p>
          <br />
          <img src={image} alt="" style={{ width: "50px", marginRight: "5px" }} />
        </center>
      </div>
    </div>
  );
}